import { NgModule } from '@angular/core';
import { ContactComponent } from './contact.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';


@NgModule({
    imports: [FormsModule,CommonModule],
   exports: [ContactComponent],
   declarations: [ContactComponent],
   providers: [],
})
export class ContactModule{ }